export class UserError extends Error {
  constructor(message: string) {
    super('[UserError] ' + message);
  }
}

// Operation Errors
export class UserCreationError extends UserError {}
export class UserRetrievalError extends UserError {}
export class UserUpdateError extends UserError {}
export class UserDeletionError extends UserError {}

// Authorization Errors
export class UserUnauthorizedError extends UserError {}
export class UserForbiddenError extends UserError {}
export class UserNotFoundError extends UserError {}

// Conflict Error
export class UserConflictError extends UserError {}

// Server Error
export class UserServerError extends UserError {}
